export const QR_SERVICE_API_URL = ''